import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">SmartRepair</h3>
            <p className="text-gray-300">
              Connecting vehicle owners with reliable repair centers for seamless service management.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/repair-centers" className="text-gray-300 hover:text-white">Find Repair Centers</a></li>
              <li><a href="/appointments" className="text-gray-300 hover:text-white">Book Appointment</a></li>
              <li><a href="/spare-parts" className="text-gray-300 hover:text-white">Order Spare Parts</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Email: support@smartrepair.com</li>
              <li>Phone: +1 234-567-8900</li>
              <li>Address: 123 Repair Street</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white">
                <FaFacebook size={24} />
              </a>
              <a href="#" className="text-gray-300 hover:text-white">
                <FaTwitter size={24} />
              </a>
              <a href="#" className="text-gray-300 hover:text-white">
                <FaInstagram size={24} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-300">
          <p>&copy; {new Date().getFullYear()} SmartRepair. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;